import { proxy } from 'valtio';
import type { EmailFileAttachment, ImageFileAttachment, TabularFileAttachment } from '../providers/AIContext';

export type StoredTempAttachment = TabularFileAttachment | ImageFileAttachment | EmailFileAttachment;

interface UserTempInventoryState {
  files: StoredTempAttachment[];
  loading: boolean;
  ready: boolean;
  userId: string | null;
}

export const userTempInventoryState = proxy<UserTempInventoryState>({
  files: [],
  loading: false,
  ready: false,
  userId: null,
});
